const terms = `
퀵 이용 약관 표시 

`
export default terms;